import React, { useRef, useState } from 'react';
import { MdDownload } from 'react-icons/md';
import './itineraryMenu.css';
import { toPng } from 'html-to-image';
import L from 'leaflet';
import html2pdf from 'html2pdf.js';
import { BsChevronDown } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { PathSegment } from '../../types/types'
import { generateGPXContent } from '../../utils/generateGPXContent'
import { handleGoToPdf } from '../../utils/handleGoToPdf'
import { downloadGPX } from '../../utils/downloadGpx'
import { FaRegTrashAlt } from "react-icons/fa";


interface ItineraryMenuProps {
  currentSequence: string[];
  pathCoords: Array<PathSegment>;
  setCurrentSequence: React.Dispatch<React.SetStateAction<string[]>>;
  setPathCoords: React.Dispatch<React.SetStateAction<Array<PathSegment>>>;
  setShowItinerary: React.Dispatch<React.SetStateAction<boolean>>;
  isCollapsed?: boolean;
  setIsCollapsed?: (collapsed: boolean) => void;
}

export const ItineraryMenu: React.FC<ItineraryMenuProps> = ({ currentSequence, pathCoords, setCurrentSequence, setPathCoords, setShowItinerary, isCollapsed, setIsCollapsed }) => {
  const [showModal, setShowModal] = useState(false);
  const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);
  const navigate = useNavigate();

  const totalDistance = pathCoords.reduce((acc, segment) => acc + segment.distance, 0);
  const mapRef = useRef<HTMLDivElement>(null);

  const deleteAll = () => {
    setCurrentSequence([])
    setPathCoords([])
  };


  const undoLast = () => {
    setCurrentSequence(currentSequence.slice(0, -1))
    setPathCoords(pathCoords.slice(0, -1))
  };

  const confirmRoute = () => {
    setShowModal(true)
  }

  const hideModal = () => {
    //deleteAll()
    setShowModal(false)
  }

  const hideList = () => {
    setShowItinerary(false)
  }

  const downloadPDF = () => {
    const mapContainer = mapRef.current as HTMLElement;
    if (!mapContainer) return;

    setIsGeneratingPDF(true)


    const blueIcon = L.icon({ iconUrl: 'https://maps.google.com/mapfiles/ms/icons/blue-dot.png', iconSize: [32, 32], iconAnchor: [16, 32], popupAnchor: [0, -32], });
    const map = L.map(mapContainer, { center: [0, 0], zoom: 13, zoomControl: false, attributionControl: false, });
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png").addTo(map);

    const gpxContent = generateGPXContent(pathCoords, currentSequence); // 
    const gpxLayer = new (L as any).GPX(gpxContent, { async: true });

    gpxLayer.on('loaded', () => {
      map.fitBounds(gpxLayer.getBounds());

      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(gpxContent, 'application/xml');
      const waypoints = xmlDoc.getElementsByTagName('wpt');

      for (let i = 0; i < waypoints.length; i++) {
        const wpt = waypoints[i];
        const lat = parseFloat(wpt.getAttribute('lat') || '0');
        const lon = parseFloat(wpt.getAttribute('lon') || '0');
        const name = wpt.getElementsByTagName('name')[0]?.textContent || `Punto ${i + 1}`;

        let icon = blueIcon;

        const marker = L.marker([lat, lon], { icon }).addTo(map);

        marker.bindTooltip(name, { permanent: false, direction: 'top', offset: [0, -10], }).openTooltip();
      }

      // const distance = getDistance(pathCoords);

    });

  };

  return (
    <div className="itinerary-menu">
      <div className="title-container">
        <span className="title-text">Ruta Personalizada</span>
      </div>
      {/* <div className="itinerary-header"> */}
      {/*   <h2>Ruta</h2> */}
      {/*   <h3>{currentSequence.length} Puntos</h3> */}
      {/* </div> */}
      <div className="itinerary-content">
        <div className="itinerary-stats">
          <div className="stat-item">
            <span className="stat-label">Distancia total: </span>
            <span className="stat-value">{(totalDistance / 1000).toFixed(2)} km</span>
          </div>
          <div className="stat-item">
            <span className="stat-label">Nº Puntos:</span>
            <span className="stat-value">{currentSequence.length}</span>
          </div>
        </div>
        <div className="itinerary-points">
          {currentSequence.map((point, index) => (
            <div key={`${point}-${index}`}>
              <div className="itinerary-point">
                <span className="point-id">Punto {point}</span>
                {index === currentSequence.length - 1 && (
                  <button
                    onClick={undoLast}
                    className="erase-button"
                    style={{
                      marginLeft: '8px',
                      padding: '2px 6px',
                      backgroundColor: '#ff6b6b',
                      color: 'white',
                      border: 'none',
                      borderRadius: '4px',
                      fontSize: '12px',
                      cursor: 'pointer'
                    }}
                  >
                    <FaRegTrashAlt />
                  </button>
                )}
              </div>
              {index !== currentSequence.length - 1 && (
                <span className="point-arrow">↓</span>
              )}
            </div>
          ))
          }
        </div>

        <div className='buttons'>
          <button onClick={confirmRoute} className='btn btnTerminar'>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="1em"
              height="1em"
              style={{ marginRight: "8px" }}
            >
              <path
                fill="currentColor"
                d="M9 16.17L4.83 12l-1.42 1.41L9 19L21 7l-1.41-1.41z"
              ></path>
            </svg>
            Terminar</button>
          <button onClick={undoLast} className='btn btnDeshacer'>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="1em"
              height="1em"
              style={{ marginRight: "8px" }}
            >
              <path
                fill="currentColor"
                fillRule="evenodd"
                d="M7.53 3.47a.75.75 0 0 1 0 1.06L5.81 6.25H15a5.75 5.75 0 0 1 0 11.5H8a.75.75 0 0 1 0-1.5h7a4.25 4.25 0 0 0 0-8.5H5.81l1.72 1.72a.75.75 0 1 1-1.06 1.06l-3-3a.75.75 0 0 1 0-1.06l3-3a.75.75 0 0 1 1.06 0"
                clipRule="evenodd"
              ></path>
            </svg>
            Deshacer</button>
          <button onClick={deleteAll} className='btn btnBorrar'>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="1em"
              height="1em"
              style={{ marginRight: "8px" }}
            >
              <path
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M5 7h14m-9 3v8m4-8v8M10 3h4a1 1 0 0 1 1 1v3H9V4a1 1 0 0 1 1-1M6 7h12v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1z"
              ></path>
            </svg>
            Borrar todo</button>
        </div>

      </div>

      {showModal && (
        <div className="modal-overlay">
          <div className="modal">
            <button onClick={() => hideModal()}> Cerrar</button>
            <div className="icon-check">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="10" fill="#10B981" />
                <path d="M16 10l-4.5 4.5L8 11" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>

            <h4>Ruta generada correctamente</h4>
            <h2 className='text-modal'>¿Cómo quieres descargarla?</h2>
            <div className='modal-buttons'>
              <button className='btn-gpx' onClick={() => downloadGPX(pathCoords, currentSequence)}>
                <MdDownload size={24} style={{ marginRight: "8px" }} />
                GPX</button>
              <button className='btn-gpx' onClick={() => handleGoToPdf(currentSequence, pathCoords, navigate)} disabled={isGeneratingPDF}>

                <MdDownload size={24} style={{ marginRight: "8px" }} />
                {isGeneratingPDF ? 'Generando PDF' : 'PDF'}
              </button>
              {/* <button className='btn-gpx' onClick={() => handleGoToPdf(currentSequence, pathCoords, navigate)} > */}
              {/*   Route */}
              {/* </button> */}
            </div>
          </div>
          {/* <div ref={mapRef} style={{ position: 'absolute', zIndex: -999, border: '1px solid red' }}></div> */}
          <div ref={mapRef}
            style={{ position: 'fixed', top: 0, left: 0, zIndex: -999, pointerEvents: 'none' }}
          ></div>
        </div>
      )}
    </div>

  );
}; 
